/**
 * Job type enum
 * Represents the different types of background jobs that can be processed
 */
export enum JOB_TYPE {
    IMPORT_PBI_DATA = 'IMPORT_PBI_DATA',
    PREPARE_PLANNER_TEMPLATE = 'PREPARE_PLANNER_TEMPLATE',
    PREPARE_AI_TEMPLATE = 'PREPARE_AI_TEMPLATE'
}

/**
 * Job status enum
 * Represents the various states a job can be in during its execution lifecycle
 */
export enum JOB_STATUS {
    CREATED = 'CREATED',
    RUNNING = 'RUNNING',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED'
}

/**
 * Job interface
 * Represents a background job in the system with all its properties
 */
export interface IJob {
    /** Unique identifier for the job (UUID) */
    id?: string;
    
    /** Type of job */
    type: JOB_TYPE;
    
    /** Current status of the job */
    status: JOB_STATUS;
    
    /** Timestamp when the job was created (timestamp with time zone) */
    created_at?: string;
    
    /** Timestamp when the job was last updated (timestamp with time zone) */
    updated_at?: string;
    
    /** ID of the associated forecast, if applicable (UUID) */
    forecast_id?: string;
}